import {situacoesSolicitacoesCredenciamento} from '../constants'

const filtroStatusLicitacao = function (status) {
    return situacoesSolicitacoesCredenciamento.hasOwnProperty(status) ? situacoesSolicitacoesCredenciamento[status] : status
}

export default filtroStatusLicitacao
